import { render, staticRenderFns } from "./SitesTable.vue?vue&type=template&id=05601e54&scoped=true"
import script from "./SitesTable.vue?vue&type=script&lang=js"
export * from "./SitesTable.vue?vue&type=script&lang=js"
import style0 from "./SitesTable.vue?vue&type=style&index=0&id=05601e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05601e54",
  null
  
)

export default component.exports